// R1d.8 — Honest 404 for unknown/disabled service category slugs.
// Sets noindex meta + returns a truthful message pointing users back to
// the full services grid. Never silently redirects (per directive).
import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import PublicShell from "../../components/public/PublicShell";
import SEOHead from "../../components/public/SEOHead";

export default function CategoryNotFound() {
  const { slug } = useParams();

  useEffect(() => {
    // Signal 404 to any headless-browser prerenderer / uptime monitor via
    // a marker attribute the crawler can pick up. Real HTTP 404 is not
    // possible from a SPA route without SSR.
    document.body.setAttribute("data-http-status", "404");
    return () => document.body.removeAttribute("data-http-status");
  }, []);

  const hero = (
    <section className="erf-public-hero" data-testid="category-404-hero" style={{ padding: "72px 0 56px" }}>
      <div className="erf-public-container">
        <div className="erf-public-hero-eyebrow">Not found</div>
        <h1 style={{ maxWidth: 800 }}>Category not found.</h1>
        <p className="lead">
          The service category <code style={{ fontFamily: "ui-monospace, monospace", background: "var(--exec-bg-alt)", padding: "2px 8px", borderRadius: 4 }}>{slug || "unknown"}</code> is not one we currently offer. Browse every service we deliver on the full <Link to="/services" style={{ color: "var(--exec-accent)", textDecoration: "underline" }}>Services</Link> page.
        </p>
      </div>
    </section>
  );

  return (
    <PublicShell hero={hero}>
      <SEOHead
        title="Category not found — ERF ENTERPRISES LLC"
        description="This service category does not exist. Browse the full ERF services catalog."
        noindex={true}
      />
      <section className="erf-public-section" data-testid="category-404-body">
        <div className="erf-public-container" style={{ padding: "16px 24px 40px" }}>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <Link to="/services" className="erf-public-cta" data-testid="category-404-back-to-services">
              View all services
            </Link>
            <Link to="/" className="erf-public-cta-outline" data-testid="category-404-home">
              Return home
            </Link>
          </div>
        </div>
      </section>
    </PublicShell>
  );
}
